module.exports = __webpack_public_path__ + "media/images/gallery/constellations/ursa_minor/umi_lines-d202d33aca08aa110eb02b6e1755336b.gif";